import type { CitizenCountry } from '../types/citizen';

interface CountryFlagProps {
  country: CitizenCountry;
}

export function CountryFlag({ country }: CountryFlagProps) {
  if (country.flagUrl) {
    return <img className="country-flag" src={country.flagUrl} alt={`${country.name} flag`} />;
  }

  return (
    <span className="country-flag country-flag--emoji" role="img" aria-label={`${country.name} flag`}>
      {country.flagEmoji ?? '◈'}
    </span>
  );
}

